export const isBuildFlagEnabled = (value: string | undefined): boolean =>
  value === 'true';

export const OPTION_TOOLS_ENABLED = isBuildFlagEnabled(
  process.env.REACT_APP_OPTION_TOOLS_ENABLED,
);
